import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
`;
